import { useActionErrorNotification } from '~/hooks/useActionErrorNotification'
import { getActionErrorPayload } from '~/utils/actionErrorPayload'

import { useActionData } from '@remix-run/react'

/** Must render in the same route module tree as the route action. */
export function RouteActionErrorListener() {
  useActionErrorNotification(getActionErrorPayload(useActionData()))
  return null
}
